// react-bootstrap imports
import { useState, useEffect } from "react"

import { dadosImovel } from "pages/TaxasCTM24/CalcularTaxaServico/GerarDocumento"

import { autoFill, dropdownsWithDefaultValue, getFormData } from "services/FormFunctions"
import { obsDocumento } from "services/InputFieldsDocumentos"
import { ChecarCondicoesAntesEnviar, ChamarGerador } from "services/TaxasCTM24/CalcularTaxaServico/GerarDocumento"

import * as Links from "constants/links"
import { ZonaDoBairro } from "constants/bairrosZona"
import { WarningIncompleteInputMessage } from "./useAlert"
import { useNavigate } from "react-router-dom"
import { inputGroupNames } from "constants/inputGroupNames"

let fieldError = false

function useToaster(HeaderMessage = "", BodyMessage = "", Variation = "")
{   
    const [showToaster, setShowToaster] = useState(false)
    const [headerMsg, setHeaderMsg] = useState(HeaderMessage)
    const [bodyMsg, setBodyMsg] = useState(BodyMessage)
    const [variation, setVariation] = useState(Variation)

    function changeMsg(headerMsg, bodyMsg, variation)
    {
        setHeaderMsg(headerMsg)
        setBodyMsg(bodyMsg)
        setVariation(variation)
    }

    return {
        HeaderMessage: headerMsg, 
        BodyMessage: bodyMsg, 
        Variation: variation,
        show: showToaster, 
        open: () => setShowToaster(true),
        close: () => setShowToaster(false),
        changeMsg: changeMsg
    }
}

export function getField(fieldName)
{
    const fieldsWithName = document.getElementsByName(fieldName)

    if (fieldsWithName.length <= 0) { console.log("Error: Extraindo valor de campo pelo seu nome, porém não existe campo com o nome " + fieldName) ; return }
    if (2 <= fieldsWithName.length) { console.log("Aviso: Extraindo valor de campo pelo seu nome, porém mais de um campo possui este name") }

    return document.getElementsByName(fieldName)[0]
}

// function getFieldValue(fieldName)
// {
//     const fieldsWithName = document.getElementsByName(fieldName)

//     if (fieldsWithName.length <= 0) { console.log("Error: Extraindo valor de campo pelo seu nome, porém não existe campo com o nome " + fieldName) ; return }
//     if (2 <= fieldsWithName.length) { console.log("Aviso: Extraindo valor de campo pelo seu nome, porém mais de um campo possui este name") }

//     return document.getElementsByName(fieldName)[0].value
// }

function validateForm()
{
    const invalidDropdowns = dropdownsWithDefaultValue()

    // validar máscaras
    if (1 <= invalidDropdowns.length) { return "Campo não selecionado: " + invalidDropdowns[0].name } // passar isso pro campo

}

export function useSalvarCarregarDados()
{
    // TODO passar as coisas de salvar e carregar dados pra cá
}

export function registerFieldError(hasError)
{
    fieldError = hasError
}

export function useGerarDocumento(dadosDoc, guiaData, procData, tipoDoc, subTipoDoc, showAlert) 
{
    const navigate = useNavigate()
    const [isLoading, setLoading] = useState(false)
    const [validated, setValidated] = useState(false)
    const [showMap, setShowMap] = useState(false)
    const [expandedForm, setExpandedForm] = useState(false)
    // const [showSuccessDocumentoGerado, setShowSuccessDocumentoGerado] = useState(false)
    const [showAlertNoData, setShowAlertNoData] = useState(false)
    const [showAlertDataSaved, setShowAlertDataSaved] = useState(false)
    const [showAlertDataLoaded, setShowAlertDataLoaded] = useState(false)
    // const [showErrorMessage, setShowErrorMessage] = useState(false)
    const toaster = useToaster()
    const [amountGroupFields, setAmountGroupFields] = useState({})

    function onClickShowMap() { setShowMap(!showMap) }
    
    useEffect(() => {
        setAmountGroupFields(
            {
                "loteDescricaoAreaDemarcada": dadosDoc?.descConfront?.areasDemarcadas.filter(text => text.trim() !== "")?.length ?? 0,
                "loteDescricaoAreaDesmembrada": dadosDoc?.descConfront?.areasDesmembradas.filter(text => text.trim() !== "")?.length ?? 0,
                "loteDescricaoAreaRemembrada": dadosDoc?.descConfront?.areasRemembradas.filter(text => text.trim() !== "")?.length ?? 0,
                "obs":  dadosDoc?.obs?.observacoes?.length ?? obsDocumento(tipoDoc, subTipoDoc)?.length ?? 0,
                "pavimentos": dadosDoc?.pavimentos?.pavimentos?.length ?? 0,
                "registrosMatriculas": dadosDoc?.especificAutorizacao?.registros?.length ?? 0,
                "areasLotes": dadosDoc?.areasLotes?.areas?.length ?? 0,
                "areasVerdes": dadosDoc?.areasVerdes?.areas?.length ?? 0,
                "areasSistViario": dadosDoc?.areasSistViario?.areas?.length ?? 0,
                "responsaveisTecnicos": dadosDoc?.respTecs?.respTecs?.length ?? 0,
                "unidadesHabitacionais": dadosDoc?.unidHabit?.unidsHabitacionais?.length ?? 0
            }
        )
        setExpandedForm(true)
    }, [expandedForm, dadosDoc])

    useEffect(() => {
        if (dadosDoc || guiaData)
        {
            const guiaDataWithoutNumDoc = {...guiaData, numDoc: null}
            const camposNaoEditaveis = 
            {
                numProc: dadosDoc?.procData?.numProc ?? guiaData?.procData?.numProc,
                anoProc: dadosDoc?.procData?.anoProc ?? guiaData?.procData?.anoProc,
                valorDosServicos: guiaData?.detalhesGuia?.taxInputs?.valorContrato,
                ...dadosDoc?.guiaOrigemData?.detalhesGuia?.taxInputs ?? guiaData?.detalhesGuia?.taxInputs
            }
            autoFill(dadosDoc ?? {...procData,
                                    ...guiaDataWithoutNumDoc,
                                    ...dadosImovel(guiaData),
                                    valorDosServicos: guiaData?.detalhesGuia?.taxInputs?.valorContrato, // TODO colocar mesmo nome do input da Dora, ajustar o BD e tirar dqui e dos camposNaoEditaveis acima
                                    macrozoneamento: ZonaDoBairro(guiaData?.enderecoProprietario?.bairroProprietario)
                                }
                , false, camposNaoEditaveis)
        }
    },[amountGroupFields, expandedForm, dadosDoc, guiaData, procData])

    function RedirectDocGeradoComSucesso(tipoDoc, subTipoDoc, numProc, anoProc)
    {
        const state = {tipoDoc, subTipoDoc, numProc, anoProc}
        navigate(Links.DOC_GERADO_COM_SUCESSO, {state: state})
    }

    async function handleSubmit(event, editar, tipoDoc, subTipoDoc, guiaData, dadosDoc)
    {    
        const form = event.currentTarget
        event.preventDefault()

        const formError = validateForm()
        if (!form.checkValidity() || fieldError || formError)
        {
            event.stopPropagation()
            setValidated(false)
            const message = WarningIncompleteInputMessage()
            showAlert(message.variant, message.header, message.body)
            window.scrollTo(0, 0)
            
            /*toaster.changeMsg(
                "Erro ao preencher formulário",
                formError ?? "Algum (ns) dos campos não estão preenchidos de forma correta, favor checar o formulário.",
                "danger"
            )
            toaster.open()*/
            return
        }

        const formData = getFormData(form)
        const numProc = guiaData?.numProc ?? dadosDoc?.numProc ?? formData.numProc
        const anoProc = guiaData?.anoProc ?? dadosDoc?.anoProc ?? formData.anoProc
        const idProc = procData?.id
        const idDoc = dadosDoc?.id

        const msgErro = ChecarCondicoesAntesEnviar(idProc, numProc, anoProc)
        if(msgErro)
        {
            showAlert(msgErro.variant, msgErro.header, msgErro.body)
            window.scrollTo(0, 0)
        }
        else
        {
            setValidated(true)
            setLoading(true)
            const resultMsg = await ChamarGerador(tipoDoc, subTipoDoc, formData, guiaData, dadosDoc, editar, numProc, anoProc, idProc, idDoc, true)
            if (resultMsg?.variant !== "danger" && !editar)
            {
                RedirectDocGeradoComSucesso(tipoDoc, subTipoDoc, numProc, anoProc)
            }
            else
            {
                showAlert(resultMsg.variant, resultMsg.header, resultMsg.body)
                window.scrollTo(0, 0)
            }
            
            setLoading(false)
        }
    }

    return {
        isLoading,
        validated,
        showMap,
        showAlertNoData,
        setShowAlertNoData,
        showAlertDataSaved,
        setShowAlertDataSaved,
        showAlertDataLoaded,
        setShowAlertDataLoaded,
        toaster,
        amountGroupFields,
        setAmountGroupFields,
        onClickShowMap,
        handleSubmit
    }
}